<template>
  <div>
    <template v-if="data != null">
      <v-row dense>
        <v-col cols="12" align="center">
          <v-btn :elevation="displayInfo === 0 ? 6 : 0" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark @click="changeDisplayInfo(0)" :color="displayInfo === 0 ? 'primary' : 'grey'">
            {{ $t("basic.actual") }}
          </v-btn>
          <v-btn :elevation="displayInfo === 1 ? 6 : 0" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark @click="changeDisplayInfo(1)" :color="displayInfo === 1 ? 'primary' : 'grey'">
            {{ $t("basic.today") }}
          </v-btn>
          <v-btn :elevation="displayInfo === 2 ? 6 : 0" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark @click="changeDisplayInfo(2)" :color="displayInfo === 2 ? 'primary' : 'grey'">
            {{ $t("basic.yesterday") }}
          </v-btn>
          <v-btn :elevation="displayInfo === 3 ? 6 : 0" outlined :x-small="windowWidth < 400 ? true : false" :small="windowWidth > 400 && windowWidth < 800 ? true : false" class="ma-2" dark @click="changeDisplayInfo(3)" :color="displayInfo === 3 ? 'primary' : 'grey'">
            {{ $t("basic.thisMonth") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" class="ma-4">
          <v-row class="ma-2">
            <!-- :style="getWidth('sides')" -->
            <v-col class="pa-0" cols="3" md="2" offset-md="2" offset-sm="1" offset="1" align="center">
              <AvatarUnit2
                :avatarSize="mobile === true ? 1.85 * currentSizeIcons.size : 1.35 * currentSizeIcons.size"
                :iconStyle="currentSizeIcons"
                :icons="[data.pv.state != 'ON' ? 'mdi-weather-night-partly-cloudy' : 'mdi-solar-power']"
                :colors="[data.pv.state != 'ON' ? 'blue-grey darken-1' : 'yellow darken-2']"
                :colorsAvatar="[data.pv.state != 'ON' ? 'blue-grey darken-1' : 'yellow darken-2']"
                :power="data.pv.powerOut"
                :carouselText2SubHeaderBot="[
                  displayInfo === 0
                    ? $t('basic.production') + ': ' + data.pv.powerOut + ' kW'
                    : displayInfo === 1
                    ? $t('basic.produced') + ': ' + data.pv.energyToday + ' kWh'
                    : displayInfo === 2
                    ? $t('basic.produced') + ': ' + data.pv.energyYesterday + ' kWh'
                    : displayInfo === 3
                    ? $t('basic.produced') + ': ' + calculated.pv.energyMonth + ' kWh'
                    : 0,
                ]"
                :carouselText2SubHeaderBotStyle="[data.pv.state == 'OFF' ? 'color: #546E7A;' : 'color: #FBC02D;']"
              />
            </v-col>

            <v-col class="pa-0" cols="3" md="2" offset="4" align="center">
              <AvatarUnit2
                :avatarSize="mobile === true ? 1.85 * currentSizeIcons.size : 1.35 * currentSizeIcons.size"
                :iconStyle="currentSizeIcons"
                :icons="data.grid.power >= 0 ? ['mdi-transmission-tower'] : ['mdi-transmission-tower']"
                :colors="['purple', 'blue']"
                :colorsAvatar="data.grid.power >= 0 ? ['purple', 'purple'] : ['blue', 'blue']"
                :power="data.grid.power"
                :carouselTextSubHeaderBot="[
                  displayInfo === 0
                    ? $t('basic.gridImport') + ': ' + data.grid.powerImport + ' kW'
                    : displayInfo === 1
                    ? $t('basic.gridImport') + ': ' + data.grid.energyConsumptionToday + ' kWh'
                    : displayInfo === 2
                    ? $t('basic.gridImport') + ': ' + data.grid.energyConsumptionYesterday + ' kWh'
                    : displayInfo === 3
                    ? $t('basic.gridImport') + ': ' + calculated.grid.energyImportMonth + ' kWh'
                    : 0,
                  displayInfo === 0
                    ? $t('basic.gridExport') + ': ' + data.grid.powerExport + ' kW'
                    : displayInfo === 1
                    ? $t('basic.gridExport') + ': ' + data.grid.energyOverflowsToday + ' kWh'
                    : displayInfo === 2
                    ? $t('basic.gridExport') + ': ' + data.grid.energyOverflowsYesterday + ' kWh'
                    : displayInfo === 3
                    ? $t('basic.gridExport') + ': ' + calculated.grid.energyExportMonth + ' kWh'
                    : 0,
                ]"
                :carouselTextSubHeaderBotStyle="['color: purple;', 'color: blue;']"
              />
            </v-col>
          </v-row>
          <v-row class="ma-2">
            <v-col class="pa-0" cols="3" md="2" offset-md="2" offset-sm="1" offset="1" align="center">
              <EnergyFlow animation="down" :size="currentSizeEnergyFlow.size" :totalIcons="arrows.valueVertical" :color="data.pv.state == 'OFF' ? 'blue-grey darken-1' : 'yellow darken-2'" :power="data.pv.powerOut" />
            </v-col>

            <v-col class="pa-0" cols="3" md="2" align="center" offset="4">
              <template v-if="data.grid.power < 0">
                <EnergyFlow animation="up" :size="currentSizeEnergyFlow.size" :totalIcons="arrows.valueVertical" color="blue" :power="data.grid.powerExport" />
              </template>
              <template v-else>
                <EnergyFlow animation="down" :size="currentSizeEnergyFlow.size" :totalIcons="arrows.valueVertical" color="purple" :power="data.grid.powerImport" />
              </template>
            </v-col>
          </v-row>
          <v-row class="ma-2">
            <v-col class="pa-0" cols="3" md="2" offset-md="2" offset-sm="1" offset="1" align="center">
              <AvatarUnit2
                :avatarSize="mobile === true ? 1.85 * currentSizeIcons.size : 1.35 * currentSizeIcons.size"
                :iconStyle="currentSizeIcons"
                :icons="['mdi-lightning-bolt']"
                :colors="[data.inverter.state != 'ON' ? 'blue-grey darken-1' : 'teal']"
                :colorsAvatar="[data.inverter.state != 'ON' ? 'blue-grey darken-1' : 'teal']"
                :power="data.inverter.power"
                :carouselTextSubHeaderBot="[
                  displayInfo === 0
                    ? data.inverter.power < 0
                      ? $t('basic.charging') + ': ' + Math.abs(data.inverter.power) + ' kW'
                      : $t('basic.generating') + ': ' + data.inverter.power + ' kW'
                    : displayInfo === 1
                    ? $t('basic.inverterExport') + ': ' + data.inverter.energyToday + ' kWh'
                    : displayInfo === 2
                    ? $t('basic.inverterExport') + ': ' + data.inverter.energyYesterday + ' kWh'
                    : displayInfo === 3
                    ? $t('basic.inverterExport') + ': ' + calculated.inverter.energyMonth + ' kWh'
                    : 0,
                ]"
                :carouselTextSubHeaderBotStyle="[data.inverter.state != 'ON' ? 'color: #546E7A;' : 'color: teal;']"
              />
            </v-col>

            <v-col class="pa-0" cols="4" align="center">
              <template v-if="mobile !== true">
                <br />
              </template>
              <br />

              <template v-if="data.inverter.power < 0">
                <EnergyFlow animation="left" :size="currentSizeEnergyFlow.size" :totalIcons="arrows.valueHorizontal" :color="data.inverter.state != 'ON' ? 'blue-grey darken-1' : 'teal'" :power="data.inverter.power < 0 ? Math.abs(batteryPower) : 0" />
              </template>
              <template v-else>
                <EnergyFlow animation="right" :size="currentSizeEnergyFlow.size" :totalIcons="arrows.valueHorizontal" :color="data.inverter.state != 'ON' ? 'blue-grey darken-1' : 'teal'" :power="data.inverter.power > 0 ? Math.abs(batteryPower) : 0" />
              </template>
            </v-col>
            <v-col class="pa-0" cols="3" md="2" align="center">
              <AvatarUnit2
                :avatarSize="mobile === true ? 1.85 * currentSizeIcons.size : 1.35 * currentSizeIcons.size"
                :iconStyle="currentSizeIcons"
                :icons="['mdi-home']"
                :colors="['red']"
                :colorsAvatar="['red']"
                :power="data.load.power"
                :carouselTextSubHeaderBot="[
                  displayInfo === 0
                    ? $t('basic.consumption') + ': ' + data.load.power + ' kW'
                    : displayInfo === 1
                    ? $t('basic.consumptionToday') + ': ' + data.load.energyToday + ' kWh'
                    : displayInfo === 2
                    ? $t('basic.consumptionYesterday') + ': ' + data.load.energyYesterday + ' kWh'
                    : displayInfo === 3
                    ? $t('basic.consumption') + ': ' + calculated.load.energyMonth + ' kWh'
                    : 0,
                ]"
                :carouselTextSubHeaderBotStyle="['color: red;']"
              />
            </v-col>
          </v-row>
          <v-row class="ma-2">
            <v-col class="pa-0" cols="3" md="2" offset-md="2" offset-sm="1" offset="1" align="center">
              <template v-if="batteryPower < 0">
                <EnergyFlow animation="down" :size="currentSizeEnergyFlow.size" :totalIcons="arrows.valueVertical" color="light-green" :power="data.battery.powerCharging" />
              </template>
              <template v-else>
                <EnergyFlow animation="up" :size="currentSizeEnergyFlow.size" :totalIcons="arrows.valueVertical" color="light-green" :power="data.battery.powerDischarging" />
              </template>
            </v-col>
          </v-row>

          <v-row class="ma-2">
            <v-col class="pa-0" cols="3" md="2" offset-md="2" offset-sm="1" offset="1" align="center">
              <AvatarUnit2
                :avatarSize="mobile === true ? 1.85 * currentSizeIcons.size : 1.35 * currentSizeIcons.size"
                :iconStyle="currentSizeIcons"
                :colors="['#8BC34A']"
                :colorsAvatar="['#8BC34A']"
                :power="batteryPower"
                :isBattery="true"
                :soc="soc"
                :carouselTextSubHeaderBot="[
                  displayInfo === 0
                    ? batteryPower < 0
                      ? $t('basic.batteryCharging') + ': ' + Math.abs(batteryPower) + ' kW'
                      : $t('basic.batteryDischarging') + ': ' + batteryPower + ' kW'
                    : displayInfo === 1
                    ? $t('basic.batteryCharged') + ': ' + data.battery.energyChargedToday + ' kWh'
                    : displayInfo === 2
                    ? $t('basic.batteryCharged') + ': ' + data.battery.energyChargedYesterday + ' kWh'
                    : displayInfo === 3
                    ? $t('basic.batteryCharged') + ': ' + calculated.battery.energyChargedMonth + ' kWh'
                    : 0,
                ]"
                :carouselTextSubHeaderBotStyle="['color: #8BC34A;']"
                :carouselText2SubHeaderBot="[
                  displayInfo === 0
                    ? 'SoC: ' + soc + '%'
                    : displayInfo === 1
                    ? $t('basic.batteryDischarged') + ': ' + data.battery.energyDischargedToday + ' kWh'
                    : displayInfo === 2
                    ? $t('basic.batteryDischarged') + ': ' + data.battery.energyDischargedYesterday + ' kWh'
                    : displayInfo === 3
                    ? $t('basic.batteryDischarged') + ': ' + calculated.battery.energyDischargedMonth + ' kWh'
                    : 0,
                ]"
                :carouselText2SubHeaderBotStyle="['color: #8BC34A;']"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <LoadingData />
    </template>
    <UpgradeCore />
  </div>
</template>

<script>
import UpgradeCore from "../../components/upgrade/UpgradeCore.vue";

import { mapState } from "vuex";
import LoadingData from "../../components/LoadingData.vue";

import AvatarUnit2 from "../../components/basic/AvatarUnit2.vue";
import EnergyFlow from "../../components/basic/EnergyFlow.vue";

import { ServiceClient } from "../../service_client/index.js";

export default {
  name: "Basic",
  props: {},
  components: {
    AvatarUnit2,
    LoadingData,
    EnergyFlow,
    UpgradeCore,
  },
  data() {
    return {
      timerAPI: null,
      timerAPI2: null,

      soc: null,

      displayInfo: 0,

      icons: {
        padding: 360,
        minSize1Icon: 48,
        maxSize1Icon: 120,
        minSize2Icons: 24,
        maxSize2Icons: 60,
      },

      arrows: {
        padding: 500,

        valueVertical: 2,
        valueHorizontal: 6,
        minVertical: 1,
        maxVertical: 20,
        minHorizontal: 1,
        maxHorizontal: 32,

        minSize: 24,
        maxSize: 125,
      },

      currentSizeIcons: {
        fontSize: 120 + "px",
        size: 120,
      },

      currentSize2Icons: {
        fontSize: (120 * 2) / 3 + "px",
        size: (120 * 2) / 3,
      },

      currentSizeEnergyFlow: {
        fontSize: 32 + "px",
        size: 32,
      },

      arrowTopVertical: 3,
      arrowTopHorizontal: 12,
      arrowBottomVertical: 3,
      arrowBottomHorizontal: 7,

      calculated: {
        load: {
          energyMonth: 0,
        },
        pv: {
          energyMonth: 0,
        },
        battery: {
          energyChargedMonth: 0,
          energyDischargedMonth: 0,
        },
        grid: {
          energyImportMonth: 0,
          energyExportMonth: 0,
        },
        inverter: {
          energyMonth: 0,
        },
      },

      batteryPower: 0,

      mobile: false,

      data: null,
      chartSamples: null,

      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    };
  },
  created() {
    this.getBreakpoints();
    this.onResize();

    this.getData();
    this.getChartSamples();
  },
  mounted() {
    this.pollData();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
    changeDisplayInfo(number) {
      this.displayInfo = number;
    },
    calculateNumberOfArrows(width, padding) {
      let w3 = width / 3;

      let paddingEnergyFlow = this.currentSizeEnergyFlow.size * 1.25;
      let a = w3 / paddingEnergyFlow;

      let l = Math.floor(a);

      this.arrows.valueHorizontal = l;

      if (this.mobile) {
        this.arrows.valueVertical = 2;
      } else {
        if (width > 2000) {
          this.arrows.valueVertical = 4;
        } else if (width > 1000) {
          this.arrows.valueVertical = 3;
        }
      }

      this.limitNumberOfArrows();
    },
    limitNumberOfArrows() {
      if (this.arrows.valueVertical > this.arrows.maxVertical) {
        this.arrows.valueVertical = this.arrows.maxVertical;
      }
      if (this.arrows.valueVertical < this.arrows.minVertical) {
        this.arrows.valueVertical = this.arrows.minVertical;
      }

      if (this.arrows.valueHorizontal > this.arrows.maxHorizontal) {
        this.arrows.valueHorizontal = this.arrows.maxHorizontal;
      }
      if (this.arrows.valueHorizontal < this.arrows.minHorizontal) {
        this.arrows.valueHorizontal = this.arrows.minHorizontal;
      }
    },
    setArrowSize() {},
    calculateArrowSize() {},
    calculateCurrentIconsSize(width, padding, minSize, maxSize, minSize2, maxSize2) {
      let l = (width - padding) / 5;

      this.currentSizeIcons.fontSize = l + "px";
      this.currentSizeIcons.size = l;

      this.currentSize2Icons.fontSize = (l * 2) / 3 + "px";
      this.currentSize2Icons.size = (l * 2) / 3;

      this.limitCurrentSizeIcons(minSize, maxSize);
      this.limitCurrentSize2Icons(minSize2, maxSize2);
    },
    limitCurrentSizeIcons(min, max) {
      if (this.currentSizeIcons.size > max) {
        this.currentSizeIcons.fontSize = max + "px";
        this.currentSizeIcons.size = max;
      }
      if (this.currentSizeIcons.size < min) {
        this.currentSizeIcons.fontSize = min + "px";
        this.currentSizeIcons.size = min;
      }
    },
    limitCurrentSize2Icons(min, max) {
      if (this.currentSize2Icons.size > max) {
        this.currentSize2Icons.fontSize = max + "px";
        this.currentSize2Icons.size = max;
      }
      if (this.currentSize2Icons.size < min) {
        this.currentSize2Icons.fontSize = min + "px";
        this.currentSize2Icons.size = min;
      }
    },
    limitNumberOfArrows(object, min, max) {},
    onResize() {
      this.getBreakpoints();

      this.calculateCurrentIconsSize(this.windowWidth, this.icons.padding, this.icons.minSize1Icon, this.icons.maxSize1Icon, this.icons.minSize2Icons, this.icons.maxSize2Icons);

      this.calculateNumberOfArrows(this.windowWidth, this.arrows.padding);
    },
    getBreakpoints() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;

      if (this.windowWidth < 768) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
    pollData() {
      this.timerAPI = setInterval(() => {
        this.getData();
      }, 2500);
      this.timerAPI2 = setInterval(() => {
        this.getChartSamples();
      }, 20000);
    },
    getData() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("main"), null, null, "GET")
        .then((data) => {
          this.data = data;

          if (this.data.load.energyToday < 0) {
            this.data.load.energyToday = 0;
          }
          if (this.data.load.energyYesterday < 0) {
            this.data.load.energyYesterday = 0;
          }
          if (this.data.grid.energyConsumptionToday < 0) {
            this.data.grid.energyConsumptionToday = 0;
          }
          if (this.data.grid.energyConsumptionYesterday < 0) {
            this.data.grid.energyConsumptionYesterday = 0;
          }
          if (this.data.grid.energyOverflowsToday < 0) {
            this.data.grid.energyOverflowsToday = 0;
          }
          if (this.data.grid.energyOverflowsYesterday < 0) {
            this.data.grid.energyOverflowsYesterday = 0;
          }

          this.data.inverter.energyToday = Math.round((this.data.load.energyToday - this.data.grid.energyConsumptionToday + this.data.grid.energyOverflowsToday) * 100) / 100;
          this.data.inverter.energyYesterday = Math.round((this.data.load.energyYesterday - this.data.grid.energyConsumptionYesterday + this.data.grid.energyOverflowsYesterday) * 100) / 100;

          if (this.data.inverter.energyToday < 0) {
            this.data.inverter.energyToday = 0;
          }
          if (this.data.inverter.energyYesterday < 0) {
            this.data.inverter.energyYesterday = 0;
          }

          if ("bat" in this.data.battery) {
            this.batteryPower = this.data.battery.bat.power;
          } else {
            this.batteryPower = this.data.battery.power;
          }

          this.data.battery.powerCharging = this.batteryPower < 0 ? Math.abs(this.batteryPower) : 0;
          this.data.battery.powerDischarging = this.batteryPower >= 0 ? this.batteryPower : 0;

          this.data.inverter.powerImport = this.data.inverter.power < 0 ? Math.abs(this.data.inverter.power) : 0;
          this.data.inverter.powerExport = this.data.inverter.power >= 0 ? this.data.inverter.power : 0;

          this.data.grid.powerExport = this.data.grid.power < 0 ? Math.abs(this.data.grid.power) : 0;
          this.data.grid.powerImport = this.data.grid.power >= 0 ? this.data.grid.power : 0;

          let averageSOC = 0;
          let batteryOnline = 0;

          if ("batteries" in this.data.battery) {
            for (let index = 0; index < this.data.battery.batteries.length; index++) {
              if (this.data.battery.batteries[index].state != "Reset") {
                averageSOC += this.data.battery.batteries[index].bms.soc;
                batteryOnline++;
              }
            }
            if (batteryOnline != 0) {
              averageSOC /= batteryOnline;
            }
          } else {
            averageSOC = this.data.battery.soc;
          }

          this.soc = averageSOC;
        })
        .catch((error) => {
          this.data = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    getChartSamples() {
      const date = new Date().toISOString();

      const year = date.substring(0, 4);

      const month = date.substring(5, 7);

      let parameters = "?time=d" + "&type=E" + "&limit=31" + "&dt1=" + year + month + "010000" + "&dt2=" + year + month + "312359";

      ServiceClient.dataCore(ServiceClient.getAPIUrl("chart"), null, parameters, "GET")
        .then((data) => {
          this.chartSamples = data;

          this.calculated.battery.energyDischargedMonth = 0;
          for (let index = 0; index < this.chartSamples.bat.length; index++) {
            this.calculated.battery.energyDischargedMonth += this.chartSamples.bat[index];
          }
          this.calculated.battery.energyDischargedMonth = Math.round(this.calculated.battery.energyDischargedMonth * 100) / 100;

          this.calculated.battery.energyChargedMonth = 0;
          for (let index = 0; index < this.chartSamples.batCharged.length; index++) {
            this.calculated.battery.energyChargedMonth += this.chartSamples.batCharged[index];
          }
          this.calculated.battery.energyChargedMonth = Math.round(this.calculated.battery.energyChargedMonth * 100) / 100;

          this.calculated.grid.energyImportMonth = 0;
          for (let index = 0; index < this.chartSamples.grid.length; index++) {
            this.calculated.grid.energyImportMonth += this.chartSamples.grid[index];
          }
          this.calculated.grid.energyImportMonth = Math.round(this.calculated.grid.energyImportMonth * 100) / 100;

          this.calculated.grid.energyExportMonth = 0;
          for (let index = 0; index < this.chartSamples.gridOverflows.length; index++) {
            this.calculated.grid.energyExportMonth += this.chartSamples.gridOverflows[index];
          }
          this.calculated.grid.energyExportMonth = Math.round(this.calculated.grid.energyExportMonth * 100) / 100;

          this.calculated.load.energyMonth = 0;
          for (let index = 0; index < this.chartSamples.load.length; index++) {
            this.calculated.load.energyMonth += this.chartSamples.load[index];
          }
          this.calculated.load.energyMonth = Math.round(this.calculated.load.energyMonth * 100) / 100;

          this.calculated.pv.energyMonth = 0;
          for (let index = 0; index < this.chartSamples.pv.length; index++) {
            this.calculated.pv.energyMonth += this.chartSamples.pv[index];
          }
          this.calculated.pv.energyMonth = Math.round(this.calculated.pv.energyMonth * 100) / 100;

          this.calculated.inverter.energyMonth = this.calculated.load.energyMonth - this.calculated.grid.energyImportMonth + this.calculated.grid.energyExportMonth;
          this.calculated.inverter.energyMonth = Math.round(this.calculated.inverter.energyMonth * 100) / 100;
        })
        .catch((error) => {
          this.chartSamples = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
  },
  beforeDestroy() {
    if (this.timerAPI != null) {
      clearInterval(this.timerAPI);
    }
    if (this.timerAPI2 != null) {
      clearInterval(this.timerAPI2);
    }

    window.removeEventListener("resize", this.onResize);
  },
  destroyed() {},
};
</script>

<style scoped>
.v-icon {
  text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
}

/* .light {
  position: relative;
  top: 150px;
}

@keyframes lineH {
  0% {
    width: 0%;
  }
  100% {
    width: 95%;
    opacity: 0;
  }
}
.lineh1 {
  position: absolute;
  right: 0;
  top: 340px;
  height: 10px;
  background: #85b085;
  animation: lineH 6s 1s infinite linear;
} */

@property --p {
  syntax: "<number>";
  inherits: true;
  initial-value: 1;
}

.pie {
  --p: 20;
  --b: 22px;
  --c: darkred;
  --w: 150px;

  width: var(--w);
  aspect-ratio: 1;
  position: relative;
  display: inline-grid;
  margin: 5px;
  place-content: center;
  font-size: 25px;
  font-weight: bold;
  font-family: sans-serif;
}
.pie:before,
.pie:after {
  content: "";
  position: absolute;
  border-radius: 50%;
}
.pie:before {
  inset: 0;
  background: radial-gradient(farthest-side, var(--c) 98%, #0000) top/var(--b) var(--b) no-repeat, conic-gradient(var(--c) calc(var(--p) * 1%), #0000 0);
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(99% - var(--b)), #000 calc(100% - var(--b)));
  mask: radial-gradient(farthest-side, #0000 calc(99% - var(--b)), #000 calc(100% - var(--b)));
}
.pie:after {
  inset: calc(50% - var(--b) / 2);
  background: var(--c);
  transform: rotate(calc(var(--p) * 3.6deg)) translateY(calc(50% - var(--w) / 2));
}
.animate {
  animation: p 1s 0.5s both;
}
.no-round:before {
  background-size: 0 0, auto;
}
.no-round:after {
  content: none;
}
@keyframes p {
  from {
    --p: 0;
  }
}
</style>
